import { FC } from "react";
import { Datagrid, List, TextField } from "react-admin";

import CustomPagination from "../../../components/CustomPagination";
import EmptyDataText from "../../../components/EmptyDataText";
import TimestampField from "../../../components/TimestampField";
import DeletePackage from "./components/DeletePackage";

const GymPackagesList: FC<any> = (props) => {
  return (
    <List
      {...props}
      sort={{ field: "createdAt", order: "desc" }}
      pagination={<CustomPagination />}
      bulkActionButtons={false}
      exporter={false}
    >
      <Datagrid rowClick="edit" empty={<EmptyDataText message="No packages yet!" />}>
        <TextField source="title.en" label="Title (En)" sortable={false} />
        <TextField source="title.ar" label="Title (Ar)" sortable={false} />
        <TextField source="fees" label="Fees" sortable={false} />
        <TextField source="days" label="Days" sortable={false} />
        <TimestampField source="createdAt" label="Created At" />
        <DeletePackage />
      </Datagrid>
    </List>
  );
};

export default GymPackagesList;
